module.exports = __webpack_public_path__ + "static/img/wdys1-1.6564e57.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdys1-1.png
// module id = 885
// module chunks = 0